export default __webpack_public_path__ + "static/media/hummus_with_roasted_red_pepper.64e11e51.jpg";